// extracted by mini-css-extract-plugin
module.exports = {"only_mobile":"a10a3f92e9--only_mobile--5mBur","only_tablet":"a10a3f92e9--only_tablet--TN5kQ","only_desktop":"a10a3f92e9--only_desktop--2sUaW"};